import { getHistoryDuration } from '@zuto/utilities'
import {
  decrementIndex,
  getEntriesUpToIndex,
  incrementIndex,
  isLastEntry
} from './history-utils'
import { HistoryAction, HistoryState } from './HistoryContext'
import HistoryEntry from './HistoryEntry'

export const createHistoryReducerWithMinimumYears = <EntryType extends HistoryEntry>(minimumYears : number) => (state: HistoryState<EntryType>,
  action: HistoryAction<EntryType>): HistoryState<EntryType> => {
  switch (action.type) {
    case 'UPDATE_ENTRY': {
      return {
        ...state,
        entries: {
          ...state.entries,
          [action.index]: action.value
        }
      }
    }
    case 'NEXT': {
      const lastEntry = isLastEntry(state.entries, state.currentIndex)
      const entriesUpToIndex = getEntriesUpToIndex(state.entries, state.currentIndex)
      const historyDuration = getHistoryDuration(entriesUpToIndex)
      if (historyDuration.years && historyDuration.years >= minimumYears) {
        if (lastEntry) {
          return {
            ...state,
            escapeAction: 'NEXT'
          }
        }
        return {
          ...state,
          entries: entriesUpToIndex,
          escapeAction: 'NEXT'
        }
      }
      return {
        ...state,
        currentIndex: incrementIndex(state.currentIndex),
        startAtEndOfEntry: false,
        escapeAction: undefined
      }
    }
    case 'PREVIOUS':
      if (state.currentIndex === '1') {
        return {
          ...state,
          escapeAction: 'PREVIOUS'
        }
      }
      return {
        ...state,
        currentIndex: decrementIndex(state.currentIndex),
        startAtEndOfEntry: true,
        escapeAction: undefined
      }
    case 'EDIT':
      return {
        ...state,
        currentIndex: action.value
      }
    default:
      return state
  }
}
